<template>
  <div>
    <section class="life-panel">
      <div class="life-filter">
        <el-input v-model="filters.propertyId" placeholder="物业编号" clearable style="width: 180px" @keyup.enter.native="search" />
        <el-input v-model="filters.propertyName" placeholder="物业名称" clearable style="width: 160px" @keyup.enter.native="search" />
        <el-input v-model="filters.communityId" placeholder="小区编号" clearable style="width: 180px" @keyup.enter.native="search" />
        <el-input v-model="filters.communityName" placeholder="小区名称" clearable style="width: 160px" @keyup.enter.native="search" />
        <el-select v-model="filters.subjectType" placeholder="主体" clearable style="width: 120px">
          <el-option label="物业" value="PROPERTY" />
          <el-option label="小区" value="COMMUNITY" />
        </el-select>
        <el-select v-model="filters.linkStatus" placeholder="链接状态" clearable style="width: 120px">
          <el-option label="有效" value="VALID" />
          <el-option label="已过期" value="EXPIRED" />
          <el-option label="停用" value="DISABLED" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column label="物业" min-width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.companyName || '-' }}</div>
            <div class="wechat-sub">{{ scope.row.companyId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="小区" min-width="160">
          <template slot-scope="scope">
            <div>{{ scope.row.communityName || '-' }}</div>
            <div class="wechat-sub">{{ scope.row.communityId || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="主体" width="90" align="center">
          <template slot-scope="scope">{{ scope.row.subjectType === 'COMMUNITY' ? '小区' : '物业' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="statusTag(scope.row.linkStatus)">{{ statusLabel(scope.row.linkStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="appId" label="AppID" width="170" />
        <el-table-column prop="pagePath" label="页面" min-width="160" />
        <el-table-column prop="envVersion" label="环境" width="90" align="center" />
        <el-table-column prop="expireAt" label="失效时间(UTC)" width="170" />
        <el-table-column prop="generatedAt" label="生成时间(UTC)" width="170" />
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" :disabled="!scope.row.openLink" @click="copyLink(scope.row.openLink)">复制链接</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="life-pagination"
        :current-page.sync="page.current"
        :page-size="page.size"
        :page-sizes="[10, 20, 50]"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize"
        @current-change="load"
      />
    </section>
  </div>
</template>

<script>
import { listWechatSchemes } from '@/api/dev/wechatApi'

export default {
  name: 'WechatSchemeList',
  data() {
    return {
      loading: false,
      rows: [],
      filters: {
        propertyId: '',
        propertyName: '',
        communityId: '',
        communityName: '',
        subjectType: '',
        linkStatus: ''
      },
      page: { current: 1, size: 10, total: 0 }
    }
  },
  created() {
    this.load()
  },
  methods: {
    statusLabel(status) {
      return ({ VALID: '有效', EXPIRED: '已过期', DISABLED: '停用' })[status] || status
    },
    statusTag(status) {
      return ({ VALID: 'success', EXPIRED: 'warning', DISABLED: 'info' })[status] || 'info'
    },
    search() {
      this.page.current = 1
      this.load()
    },
    reset() {
      this.filters = {
        propertyId: '',
        propertyName: '',
        communityId: '',
        communityName: '',
        subjectType: '',
        linkStatus: ''
      }
      this.search()
    },
    changeSize(size) {
      this.page.size = size
      this.page.current = 1
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const res = await listWechatSchemes({
          ...this.filters,
          page: this.page.current,
          row: this.page.size
        })
        this.rows = res.data || []
        this.page.total = res.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    copyLink(text) {
      const input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('已复制')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../travel/life.scss';

.wechat-sub {
  color: #6b7280;
  font-size: 12px;
}
</style>
